<template>
    <m-input :active="focus" @click="setFocus()" :helper="helperText" :error="error">
        <input class="w-full outline-none p-2 bg-transparent" :placeholder="placeholder"
               v-bind="getAttrs()" v-model="model" :readonly="readonly" @focus="updateFocus(true)"
               @blur="updateFocus(false)" ref="input" @keydown.enter="$emit('enter')"
               :class="[this.bottom || true ? 'border-b' : 'border', formatStyle]" @keyup="validateInput" @keydown="keydown"
               @input="validateInput"/>
        <slot></slot>
    </m-input>
</template>
<script>

function printableCharacter(keycode) {
    return (keycode > 47 && keycode < 58) || // number keys
        (keycode == 32 || keycode == 13) || // spacebar & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223);   // [\]' (in order)
}

// test for digits only
const inputFilter = val => /^\d*$/.test(val)

export default {
    props: {
        name: String,
        autocomplete: {
            type: Boolean,
            default: false,
        },
        max: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: "text"
        },
        value: [String, Number],
        error: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        bottom: {
            type: Boolean,
            defaulat: false
        },
        placeholder: String,
        formatStyle: {
            type: String,
            default: "w-240 border rounded-md shadow-md border-gray-400"
        }
    },
    watch: {
        // detect external change
        value(newval) {
            this.model = newval
        }
    },
    data() {
        return {
            model: this.value,
            focus: false
        };
    },
    computed: {
        helperText() {
            if (this.max != 0) {
                return `${this.model.length}/${this.max} characters`;
            }
            return "";
        }
    },
    methods: {
        keydown(evt) {
            if (this.type != 'number' || evt.altKey || evt.ctrlKey || evt.metaKey) {
                return
            }
            if (printableCharacter(evt.keyCode) && !inputFilter(evt.key)) {
                evt.preventDefault()
            }
        },
        validateInput(evt) {
            var el = evt.target
            if (this.type != 'number' || (!el.value || el.value.length == 0)) {
                this.$emit('input', el.value)
                return
            }

            if (inputFilter(el.value)) {
                el.oldValue = el.value;
                el.oldSelectionStart = el.selectionStart;
                el.oldSelectionEnd = el.selectionEnd;
                this.$emit('input', el.value)
            } else if (el.hasOwnProperty("oldValue")) {
                el.value = el.oldValue;
                this.$emit('input', el.value)
                el.setSelectionRange(
                    el.oldSelectionStart,
                    el.oldSelectionEnd
                );
            } else {
                this.$emit('input', null)
                el.value = ''
            }

        },
        getAttrs() {
            var obj = {}
            if (this.name) {
                obj.name = this.name
            }
            // Only way now to disable autocompletion
            if (!this.autocomplete) {
                obj.autocomplete = 'new-password'
            }
            return obj
        },
        updateFocus(state) {
            this.focus = state
            this.$emit('focus', state)
        },
        handleInput() {
            this.$emit('input', this.model)
        },
        setFocus() {
            this.$refs.input.focus();
        }
    }
};
</script>
